<template>
  <div class="tip-popup">
    <van-popup v-model="show" :close-on-click-overlay="true" position="bottom">
      <div class="aliVerify-box">
        <div class="aliVerify-title">
          <div class="title">请完成下方验证后继续</div>
        </div>
        <div class="aliVerify-content">
          <!-- 阿里云智能校验 -->
          <div id="aliVerify" class="ali-nc" v-if="show"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import { aliVerify } from 'utils/aliVerify'
export default {
  components: {
    [Popup.name]: Popup
  },
  props: {},
  data() {
    return {
      show: false,
      aliVerifyObj: {}
    }
  },
  mounted() {},
  methods: {
    // 获取阿里云校验参数
    getQaSubmitVerify() {
      // 如果之前已生成验证控件，先清除
      let aliVerifyEl = document.querySelector('#aliVerify')
      if (aliVerifyEl?.innerHTML) aliVerifyEl.innerHTML = ''

      let obj = {
        appkey: 'FFFF000000000182B110',
        scene: 'ic_bbs_h5',
        renderTo: 'aliVerify'
      }
      aliVerify(obj).then(data => {
        this.aliVerifyObj = { ...data, ...obj }
        this.$emit('getAliVerifyObj', this.aliVerifyObj)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-popup {
  .van-popup {
    background-color: transparent;
  }
  .aliVerify-box {
    padding-top: 70px;
    padding-bottom: 140px;
    max-height: 70%;
    background: #ffffff;
    border-radius: 30px 30px 0px 0px;
    .aliVerify-title {
      padding: 0 37px 0 30px;
      margin: 0 auto 0;
      text-align: center;
      .title {
        font-size: 36px;
        font-weight: 600;
        color: #21252d;
      }
    }
    .aliVerify-content {
      width: 578px;
      margin: 100px auto 0;
    }
  }
}
</style>
